import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://smartbreak.telepresenz.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT token to every request
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors and rate limiting globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.error || "";

    // 401 — session expired or no token
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");

      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/"
      ) {
        // Pass the server message so the login page can show it
        window.location.href = `/?reason=${encodeURIComponent(message || "Session expired. Please login again.")}`;
      }
    }

    // 403 — only logout if the account is blocked/deleted, not for permission-denied on specific endpoints
    if (status === 403 && (message.toLowerCase().includes('inactive') || message.toLowerCase().includes('deleted') || message.toLowerCase().includes('blocked'))) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      window.location.href = `/?reason=${encodeURIComponent(message || "Access denied. Contact your administrator.")}`;
    }

    return Promise.reject(error);
  }
);

export default api;
